/**
 * Vanturis — subdomain-ready host awareness for the Air & Water verticals.
 *
 * ONE Vanturis codebase, one account system, one MongoDB Marketplace.
 * The Private Aviation and Luxury Marine experiences always work at their
 * canonical paths:
 *
 *   /marketplace/private-aviation
 *   /marketplace/luxury-marine
 *
 * This module lets the SAME vertical page later mount at the ROOT of a
 * dedicated companion subdomain WITHOUT a code rewrite or a second app:
 *
 *   aviation.vanturis.com  →  Private Aviation at "/"
 *   marine.vanturis.com    →  Luxury Marine at "/"
 *
 * Activation is purely config-driven via env (empty by default → no change
 * to today's behavior). DNS + Production env wiring is an owner action and
 * is documented in /app/memory/PRD.md. This mirrors the existing Passport
 * host-aware pattern in @/passport/product.js.
 */

const parseHosts = (raw) =>
  (raw || "")
    .split(",")
    .map((h) => h.trim().toLowerCase())
    .filter(Boolean);

const AVIATION_HOSTNAMES = parseHosts(process.env.REACT_APP_AVIATION_HOSTNAMES);
const MARINE_HOSTNAMES = parseHosts(process.env.REACT_APP_MARINE_HOSTNAMES);

/**
 * Returns the vertical slug the current hostname is dedicated to, or null
 * when running on the primary host (normal path-based behavior).
 *   → "private-aviation" | "luxury-marine" | null
 */
export function activeVerticalHost() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname.toLowerCase();
  if (AVIATION_HOSTNAMES.includes(host)) return "private-aviation";
  if (MARINE_HOSTNAMES.includes(host)) return "luxury-marine";
  return null;
}
